import {createContext} from "react";
import {APIError} from "../util/http/HTTP";

interface MToast {
    showInfo: (info: string, complete?: () => void) => void,
    showSuccess: (title: string, complete?: () => void) => void,
    showError: (error: APIError | string, complete?: () => void) => void,
}

interface MAlert {
    showAlert: (title: string, message?: string, onResolve?: {title: string, onClick?: () => void}, onReject?: {title: string, onClick?: () => void}) => void
}

const defaultValue = {
    showInfo: () => {
        //
    },
    showSuccess: () => {
        //
    },
    showError: () => {
        //
    },
    dismiss: () => {
        //
    },
    showAlert: () => {
        //
    },
} as MPrompt

export type MPrompt = MToast & MAlert

export const PromptContext = createContext<MPrompt>(defaultValue)
